<template>
  <div class="content background1">
    <div class="tableBox11">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes">
            <p class="title">{{$t('label_206')}}</p>
            <div class="chooseBox spaceBetween">
              <div>
              <div class="selectBox">
                <div>
                  <div class="selectChoose" style="width:350px">
                    <div class="selectText" style="width:33%">
                      <p>{{$t('label_128')}}</p>
                    </div>
                    <div class="select" style="width:230px">
                      <el-input v-model="searchDataList.name" clearable></el-input>
                    </div>
                  </div>
                </div>
                <div class="selectChoose">
                  <div class="selectText">
                    <p>{{$t('label_567')}}</p>
                  </div>
                  <div class="select" style="width:350px">
                  	<el-autocomplete style="width:100%" v-model="searchDataList.deptName"
                  		:fetch-suggestions="querySearchAsync1" :placeholder="$t('input_14')" :trigger-on-focus="false"
                  		@select="handleSelect1" value-key="name" @clear="clearSearch(1)" clearable>
                  	</el-autocomplete>
                  </div>
                </div>
                <div class="selectChoose">
                  <div class="selectText">
                    <p>{{$t('label_109')}}</p>
                  </div>
                  <div class="select" style="width:350px">
                  	<el-autocomplete style="width:100%" v-model="searchDataList.userName"
                  		:fetch-suggestions="querySearchAsync2" :placeholder="$t('input_15')" :trigger-on-focus="false"
                  		@select="handleSelect2" value-key="fullName" @clear="clearSearch(2)" clearable>
                  	</el-autocomplete>
                  </div>
                </div>
              </div>
				<div class="selectBox">
					<div>
					  <div class="selectChoose" style="margin-left: 45px;">
						<div class="selectText" style="padding-right: 10px">
						  <p>{{$t('label_216')}}</p>
						</div>
						<div class="select" style="width:350px">
						  <el-date-picker
							v-model="Readytime"
							type="daterange"
							value-format="yyyy-MM-dd"
							:range-separator="$t('label_264')"
							:start-placeholder="$t('label_329')"
							:end-placeholder="$t('label_388')">
						  </el-date-picker>
						</div>
					  </div>
					</div>
				</div>
              </div>
              <div class="buttonBox">
                <div>
                  <div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
                </div>
              </div>
            </div>
            <div class="spotStatusNumLists" style="padding: 0 16px; margin-top: 60px" >
              <div class="statusMesBox" v-for="(item,index) in spotStatusNumList" :class="item.check==true?'checks':''">
                <div class="iconBox" :style="{'background':item.color}"><i :class="item.icon"></i></div>
                <div class="textBox">
                  <p>{{item.text}}</p>
                  <p class="num" :style="{'color':item.color}">{{item.num}}</p>
                </div>
                <div class="checkBox" v-if="item.text != $t('label_272')">
                  <el-checkbox label="" v-model="item.check"></el-checkbox>
                </div>
              </div>
            </div>
            <div class="spotMes2Box" style="height: calc(100% - 280px);">
              <div class="buttonBox">
                <div>
                  <div class="chooseButton searchButton" v-if="MenuRoleList.indexOf('178')>=0" @click="checkResults">{{$t('btn_40')}}</div>
                </div>
              </div>
              <div class="tableMin">
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTreeTime"
                          border height="460" style="width: 100%;margin:10px 0 10px 0;" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                  <el-table-column
                    header-align="center"
                    align="center"
                    :label="$t('label_369') + '.'"
                    type="index"
                    :index="getIndex"
                    width="50"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    :label="$t('label_106')"
                    align="center"
                    width="200"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="beginTime"
                    :label="$t('label_222')"
                    align="center"
                  >
					<template slot-scope="scope">
						<p>
							{{scope.row.beginTime != null ? scope.row.beginTime.substring(0, 10) : '--'}}<br/>
							{{scope.row.beginTime != null ? scope.row.beginTime.substring(11, 16) : '--'}} - {{scope.row.endTime != null ? scope.row.endTime.substring(11, 16) : '--'}}
						</p>
					</template>
                  </el-table-column>
                  <el-table-column
                    prop="checkBeginTime"
                    :label="$t('label_225')"
                    align="center"
                  >
					<template slot-scope="scope">
						<p>
							{{scope.row.inspectionBeginTime != null ? scope.row.inspectionBeginTime.substring(0, 10) : '--'}}<br/>
							{{scope.row.inspectionBeginTime != null ? scope.row.inspectionBeginTime.substring(11, 16) : '--'}} - {{scope.row.inspectionEndTime != null ? scope.row.inspectionEndTime.substring(11, 16) : '--'}}
						</p>
					</template>
                  </el-table-column>
                  <el-table-column
                    prop="userName"
                    :label="$t('label_170')"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="status"
                    :label="$t('label_228')"
                    align="center"
                  >
					<template slot-scope="scope">
						<p :style="{'color':spotStatusNumList[scope.row.status].color}">
							{{spotStatusNumList[scope.row.status].text}}
						</p>
					</template>
                  </el-table-column>
                </el-table>
                <div style="position: absolute;bottom: 10px;left: 30%">
                  <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
                        @parentMethod="searchPage"></Page>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <el-dialog :title="$t('btn_40')" :visible.sync="dialogSpotResult" append-to-body :close-on-click-modal='false' width="1100px"
               top="3%" :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <!-- <div class="titleMes"> -->
          <!-- <p>巡检</p> -->
          <!-- <p>巡检人员：张三</p> -->
        <!-- </div> -->
        <div class="proSpotMes">
		  <div class="proMes">
		  	<div class="proP">
		  		<p v-bind:style="styleObject4">{{inspectionDetail.record.inspectionBeginTime==null ? '':inspectionDetail.record.inspectionBeginTime}}</p>
		  		<p v-bind:style="styleObject5">{{inspectionDetail.record.inspectionEndTime==null ? '':inspectionDetail.record.inspectionEndTime}}</p>
		  	</div>
		  	<div class="proTime">
		  		<p v-bind:style="styleObject1"></p>
		  		<p v-bind:style="styleObject2"></p>
		  		<p v-bind:style="styleObject3"></p>
		  	</div>
		  	<div class="proUp">
		  		<p v-bind:style="styleObject6">{{inspectionDetail.record.beginTime==null ? '':inspectionDetail.record.beginTime}}</p>
		  		<p v-bind:style="styleObject7">{{inspectionDetail.record.endTime==null ? '':inspectionDetail.record.endTime}}</p>
		  	</div>
		  </div>
          <div class="proText">
            <p>{{$t('label_225')}} <span class="real" >{{inspectionDetail.record.inspectionDuration}}</span>分</p>
            <p><i class="cricleIcon" style="background: #3fb393"></i>{{$t('label_580')}} {{inspectionDetail.record.inspectionBeginTime==null ? '':inspectionDetail.record.inspectionBeginTime}}</p>
            <p><i class="cricleIcon" style="background: #3fb393"></i>{{$t('label_585')}} {{inspectionDetail.record.inspectionEndTime==null ? '':inspectionDetail.record.inspectionEndTime}}</p>
            <p>{{$t('label_222')}} <span class="plan">{{inspectionDetail.record.duration}}</span>分</p>
            <p><i class="cricleIcon" style="background: #0353c1"></i>{{$t('label_580')}} {{inspectionDetail.record.beginTime==null ? '':inspectionDetail.record.beginTime}}</p>
            <p><i class="cricleIcon" style="background: #0353c1"></i>{{$t('label_585')}} {{inspectionDetail.record.endTime==null ? '':inspectionDetail.record.endTime}}</p>
          </div>
          <div class="down_box">
            <div class="title_style">{{$t('label_231')}}<span class="number_one">{{inspectionDetail.record.deviceCheck}}</span><span class="number_two">/{{inspectionDetail.record.deviceUncheck}}</span></div>
            <div class="title_style">{{$t('label_234')}}<span class="number_one">{{inspectionDetail.record.infoCheck}}</span><span class="number_two">/{{inspectionDetail.record.infoUncheck}}</span></div>
          </div>
        </div>
        <div class="cehsi">
          <div class="left_box">
            <div class="left_title">{{$t('label_140')}}</div>
            <div class="content_box" style="height: 100px;" v-for="(item,index) in inspectionDetail.device" :key="index" @click="changestyle(item.id)" :class="changeid==item.id?'content_boxs':''">
              <div>{{index+1}}</div>
              <div>
               <div class="equipment_wid" style="width: 180px;">{{item.superior}}</div>
                <div class="bjmodel">{{item.typeName}}&nbsp;&nbsp;&nbsp;{{item.name}}</div>
				<div class="bjmodel">{{item.code}}</div>
              </div>
            </div>
          </div>
          <!--巡检结果-->
          <div class="right_box">
            <div class="left_title">{{$t('label_183')}}</div>
            <div class="content_box" v-for="(item,index) in infoDetail" :key="index">
              <div>{{index+1}}</div>
              <div>
                <div class="equipment_wid">{{item.name}}</div>
                <div class="bjmodel">{{item.content}}</div>
              </div>
              <div style="width: 300px;">
				  <span v-if="item.photo != null&&item.photo != ''">
					<div v-for="(item,index) in item.photo.split(',')" style="width: 50px;height: 50px;margin-left: 30px;position: relative;display: inline-block;">
						<img style="width: 30px;height: 30px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item" @click="show(item,'photo')">
					</div>
				  </span>
				  <span v-if="item.video != null&&item.video != ''">
				    <div v-for="(item,index) in item.video.split(',')" style="width: 50px;height: 50px;margin-left: 30px;position: relative;display: inline-block;">
						<img style="width: 30px;height: 30px;" src="../../assets/img/spot/video.png" @click="show(item,'video')">
				    </div>
				  </span>
			  </div>
              <div>
                <div class="type_style">{{item.checkResult}}</div>
                <div>(<span v-if="item.cycleType!= null && item.cycleType.toString()=='1'">{{item.cycle=='0'?$t('label_652'):$t('label_531')+item.cycle+$t('label_537')}}</span>
					  <span v-if="item.cycleType!= null && item.cycleType.toString()=='2'">{{item.cycle==0?weekendMesOptions[6].label:weekendMesOptions[item.cycle-1].label}}</span>
                  <span v-if="item.cycleType!= null && item.cycleType.toString()=='3'">{{item.cycle>20?$t('label_238')+item.cycle+$t('label_537'):item.cycle>10?$t('label_242')+item.cycle+$t('label_537'):$t('label_245')+item.cycle+$t('label_537')}}</span>
                  <span v-if="item.cycleType!= null && item.cycleType.toString()=='5'">{{$t('label_935')+item.cycle.split(',')[0]+$t('label_540')+item.cycle.split(',')[1]+$t('label_542')+item.cycle.split(',')[2]+$t('label_537')}}</span>
					  /{{checkText(item.method)}})</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
	<el-dialog :title="$t('label_251')" :visible.sync="dialogImg" append-to-body :close-on-click-modal='false' width="800px" id="dialogImg"
	 top="10%" :before-close="closeImg" custom-class="dialogBox" >
		<div class="dialogBoxMes" style="padding:0 20px;">
			<img style="width: 100%;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+img" >
		</div>
	</el-dialog>
	<el-dialog :title="$t('label_248')" :visible.sync="dialogVideo" append-to-body :close-on-click-modal='false' width="800px" id="dialogImg"
	 top="10%" :before-close="closeImg" custom-class="dialogBox" >
		<div class="dialogBoxMes" style="padding:20px 20px;">
			<video width="100%" height="500" controls autoplay="autoplay">
				<source :src="$store.getters.getPostUrl+'mes/sysFile/download/'+img" >
			</video>
		</div>
	</el-dialog>
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import "@/assets/css/common/spot.css"
import Page from "@/components/common/page";
import utils from '@/utils/utils'
import tree from "@/components/list/tree/checkTree";
import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
import file from "@/assets/js/file/file.js";
import inspection from "@/assets/js/inspection/inspection.js";
export default {
  name: 'spotResumePage',
  components: {
    Page,
    tree,
  },
  data() {
    return {
      bjlist:[{
        id:'0',
        name1: '机电部  车间1 产线1 放电加工机EA8',
        name2: 'YFHEGH003'
      },{
        id:'1',
        name1: '机电部  车间1 产线1 放电加工机EA8',
        name2: 'YFHEGH003'
      },{
        id:'2',
        name1: '机电部  车间1 产线1 放电加工机EA8',
        name2: 'YFHEGH003'
      },{
        id:'3',
        name1: '机电部  车间1 产线1 放电加工机EA8',
        name2: 'YFHEGH003'
      },{
        id:'4',
        name1: '机电部  车间1 产线1 放电加工机EA8',
        name2: 'YFHEGH003'
      },{
        id:'5',
        name1: '机电部  车间1 产线1 放电加工机EA8',
        name2: 'YFHEGH003'
      },{
        id:'6',
        name1: '机电部  车间1 产线1 放电加工机EA8',
        name2: 'YFHEGH003'
      }],
      inspectionresults:[{
        name1:'漏油渗油',
        name2: '查看设备周围是有痕迹',
        type:'正常',
        time: '每天/目视'
      }],
	  searchDataList: {
	  	id: '',
	  	name: '',
	  	deptId: '',
	  	userId: '',
	  	deptName: '',
	  	userName: '',
	  	inspectionStatus: [],
	  	idList: [],
	  	type: '',
		beginTime: '',
		endTime: ''
	  },
      value: '0',  // 部门默认
      optionspersonnelvalue: '0', // 人员默认
      pageNum: 1,
      pageSize: 10,
      pageCount: 0,
      Readytime: '',
      code: '',
      getTreeMes: '1',
      img:'',
      checked: false,
      dialogImg:false,
      dialogVideo:false,
      dialogSpotRemark:false,
      deviceDetailMes: {},
      dialogSpotResult: false,
      MenuRoleList: [],
      newType: {
        id: '',
        remark: ''
      },
	  spotStatusNumList: [{
		icon: 'el-icon-video-pause',
		text: this.$t('label_254'),
		check: true,
		num: '0',
		color: '#ffb400',
		type: '0'
	  }, {
		icon: 'el-icon-caret-right',
		text: this.$t('label_255'),
		check: true,
		num: '0',
		color: '#8a00ff',
		type: '1'
      }, {
        icon: 'el-icon-check',
        text: this.$t('label_258'),
        check: true,
        num: '0',
        color: '#0353c1',
		type: '2'
      }, {
        icon: 'el-icon-close',
        text: this.$t('label_261'),
        check: true,
        num: '0',
        color: '#e60000',
		type: '3'
      }, {
        icon: 'el-icon-refresh-left',
        text: this.$t('label_265'),
        check: true,
        num: '0',
        color: '#3fb393',
		type: '4'
      }, {
        icon: 'el-icon-video-pause',
        text: this.$t('label_272'),
        check: false,
        num: '0',
        color: '#cacaca'
      }],
      tableDataTree: {
        beginTime: "2022-04-05 08:00:00",
        checkBeginTime: "2022-04-06 08:00:00",
        checkDuration: "2022-04-05 08:00:00",
        checkEndTime:"2022-04-06 08:00:00",
        checkUserName: "测试",
        code: "300392",
        duration: 510,
        ename: "ICT1号试验机",
        endTime: "2022-04-06 16:30:00",
        etname: "ICT试验机",
        id: "1511375609857548289"
      },
      tableDataTreeInfo: [],
      tableDataInfo: [],
	  // inspectionDetail: [],
	  inspectionDetail: {
		record: [],
		detail: []
	  },
	  infoDetail: [],
      typeName: '',
      deptName: '',
      treeData: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: '2'
      },
      treeData2: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: '3'
      },
      checkList: [],
      weekendMesOptions: [{
      	value: '1',
      	label: this.$t('label_719')
      }, {
      	value: '2',
      	label: this.$t('label_721')
      }, {
      	value: '3',
      	label: this.$t('label_723')
      }, {
      	value: '4',
      	label: this.$t('label_725')
      }, {
      	value: '5',
      	label: this.$t('label_728')
      }, {
      	value: '6',
      	label: this.$t('label_730')
      }, {
      	value: '0',
      	label: this.$t('label_716')
      }, ],
      monthDOptions: [],
      monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
      monthOptionsObj: {
        // this.$t('label_245'): ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        // this.$t('label_242'): ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
        // this.$t('label_238'): ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      },
      tableDataTreeTime: [],
      statusText: [{
        id: '0',
        text: this.$t('btn_36'),
        color: '#3fb393'
      },
        {
          id: '1',
          text: this.$t('btn_37'),
          color: '#fe0000'
        },
        {
          id: '2',
          text: this.$t('label_443'),
          color: '#ffb400'
        },
        {
          id: '3',
          text: this.$t('label_447'),
          color: '#000000'
        },
      ],
      activeNameTree: 'first',
      status: '',

      styleObject1: {
        width: '0%'
      },
      styleObject2: {
        width: '100%',
        background: '#3fb393'
      },
      styleObject3: {
        width: '0%'
      },
      styleObject4: {
        'width': '0%',
        'text-align': 'right',
        'margin-right': '10px',
        'padding-left': '0%',
        'min-width' :'170px'
      },
      styleObject5: {
        'padding-right': '0%',
        'min-width' :'170px'
      },
      styleObject6: {
        // 'width': '0%',
        // 'text-align': 'right',
        // 'margin-right': '10px',
        // 'padding-right': '0%',
        // 'min-width' :'170px',
		'padding-right': '0%',
		'min-width': '170px'
      },
      styleObject7: {
        'padding-right': '0%',
        'min-width' :'170px'
      },
      options:[{   // 部门
        value: '全部',
        id: '0'
      },{
        value: '测试部门1',
        id: '1'
      }],
      optionspersonnel:[{
        value: '测试部门',
        id: '0'
      }],
      dateValue:[],
      changeid: '',
      ceshi: '测试部门'
    }
  },
  methods: {
    changestyle(id){
      this.changeid = id
	  inspection.selectDetailInfo({
          id: this.inspectionDetail.record.id,
          equipmentId: id}).then((response) => {
	  	const data = response.data;
	  	if (data.code == "1") {
	  		this.infoDetail = data.data;
	  	}
	  }).catch((response) => {
	  	console.log(response)
	  })
    },
    //获取时间的默认值
    getDate() {
      let start = this.Fungetdate (-7) // 7天前
      let end = this.Fungetdate (0)   // 当前时间
      this.dateValue.push(start,end)
      this.Readytime =  this.dateValue
    },
    //  当前时间
    Fungetdate (num) {
      var sdd = new Date();
      sdd.setDate(sdd.getDate() + num);
      var yyyy = sdd.getFullYear();
      // var MM = sdd.getMonth() + 1;//获取当前月份的日期
      let MM =sdd.getMonth()+1 < 10 ? '0' + (sdd.getMonth() +1): sdd.getMonth()+1
      var dd = sdd.getDate()< 10 ? '0' +sdd.getDate() :sdd.getDate()
      return yyyy + "-" + MM + "-" + dd;
    },
    selechange(){},
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    show(id,type){
      this.img=id;
      if(type=="video"){
        this.dialogVideo = true;
      }else if(type=="photo"){
        this.dialogImg = true;
      }

    },
    closeImg(){
      this.dialogImg = false;
      this.dialogVideo = false;
    },
	setCurrent(row) {
		// console.log(row);
		// this.$refs.singleTable.setCurrentRow(row);
		this.changestyle(row);
	},
    handler(row) {
		inspection.selectDetail(row.id).then((response) => {
			const data = response.data;
			if (data.code == "1") {
				this.inspectionDetail = data.data;
				this.setCurrent(this.inspectionDetail.device[0].id);
				if(this.inspectionDetail.record.inspectionEndTime!=null&&this.inspectionDetail.record.inspectionBeginTime!=null){
					var checkEndTime = new Date(this.inspectionDetail.record.inspectionEndTime).getTime();
					var checkBeginTime = new Date(this.inspectionDetail.record.inspectionBeginTime).getTime();
					var date = checkEndTime - checkBeginTime; //时间差的毫秒数
					var endTime = new Date(this.inspectionDetail.record.endTime).getTime();
					var beginTime = new Date(this.inspectionDetail.record.beginTime).getTime();

					//计划时间
					var date3 = endTime - beginTime;
					if(checkBeginTime>endTime){
						//实际点检时间 ok
						this.styleObject4.width='66%'
						this.styleObject5.width='0%'
						//计划点检时间
						this.styleObject6.width='0%'
						this.styleObject7.width='66%'

						this.styleObject1.width = '50%'
						this.styleObject2.width = '50%'
						this.styleObject3.width = '0%'
					}else if(beginTime<checkBeginTime && checkEndTime>endTime){
						var a = ((checkBeginTime-beginTime) /date3)*0.8*100
						var b = ((endTime - checkEndTime) /date3)
						//实际点检时间
						this.styleObject4.width=(a<0?0:a)+'%'
						this.styleObject5.width='0%'
						//计划点检时间
						this.styleObject6.width='0%'
						this.styleObject7.width='20%'

						this.styleObject1.width = (a<0?0:a)+'%'
						this.styleObject2.width = (100-(a<0?0:a)) +'%'
						this.styleObject3.width = '0%'
					}else if(beginTime>checkBeginTime && checkEndTime>endTime){
						//实际点检时间
						this.styleObject4.width='0%'
						this.styleObject5.width='0%'
						//计划点检时间
						this.styleObject6.width='20%'
						this.styleObject7.width='20%'

						this.styleObject1.width = '0%'
						this.styleObject2.width = '100%'
						this.styleObject3.width = '0%'
					}else if (beginTime>checkBeginTime && checkEndTime<endTime){
						var b = ((endTime - checkEndTime) /date3)*0.8*100
						//实际点检时间
						this.styleObject4.width='0%'
						this.styleObject5.width= b+'%'
						//计划点检时间
						this.styleObject6.width='20%'
						this.styleObject7.width='0%'

						this.styleObject1.width = '0%'
						this.styleObject2.width = (100-b)+'%'
						this.styleObject3.width = b+'%'
					}else{
						var a = ((checkBeginTime-beginTime) /date3)*100
						var b = ((endTime - checkEndTime) /date3)*100
						this.styleObject4.width=(a<0?0:a)+'%'
						this.styleObject5.width=(b<0?0:b)+'%'
						//计划点检时间
						this.styleObject6.width='0%'
						this.styleObject7.width='0%'

						this.styleObject1.width = (a<0?0:a)+'%'
						this.styleObject2.width = (100-(a<0?0:a) -(b<0?0:b)) +'%'
						this.styleObject3.width = (b<0?0:b)+'%'
					}
				}else{
					//实际点检时间
					this.styleObject4.paddingLeft='0%'
					this.styleObject5.paddingRight='0%'
					//计划点检时间
					this.styleObject6.paddingLeft='0%'
					this.styleObject7.paddingRight='0%'

					this.styleObject1.width = '100%'
					this.styleObject2.width = '0%'
					this.styleObject3.width = '0%'
				}
			}
		}).catch((response) => {
			console.log(response)
		})
    },
    checkDefaultValue(value) {
		if (value != null) {
			let list = JSON.parse(value);
			let text = '';
			list.forEach(function(value, index2, array) {
				if (value.check == "1") {
					text += value.name + ','
				}
			});
			return text.substring(0, text.length - 1)
		}
    },
    checkText(type) {
		if (type != null) {
			let typeText = type.toString();
			var data = this.checkList.filter(function(item) {
				return item.key == typeText;
			});
			if (data != '') {
				return data[0].val
			}
		}
    },
    saveRemark() {
    },
    newTypeSave() {
    },
    handleClose() {
      this.dialogSpotResult = false;
      this.dialogSpotRemark = false;
    },
    checkResults() {
		if(this.tableDataInfo!=null&&this.tableDataInfo!=''){
			this.dialogSpotResult = true
		}else{
			utils.messageAlert(this.$t('msg_1'), this.$t('label_358'), this.$t('label_100'));
		}
    },
    handleClickTree(tab, event) {
      this.getTreeMes = '1';
      this.deviceDetailMes = {};
      this.search({
        pageNum: 1,
        pageSize: this.pageSize,
      });
    },
    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
    },
    handleCurrentChangeTreeTime(info) {
      this.tableDataInfo = info;
      inspection.selectDetail(info.id).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.inspectionDetail = data.data;
          this.setCurrent(this.inspectionDetail.device[0].id);
          if(this.inspectionDetail.record.inspectionEndTime!=null&&this.inspectionDetail.record.inspectionBeginTime!=null){
            var checkEndTime = new Date(this.inspectionDetail.record.inspectionEndTime).getTime();
            var checkBeginTime = new Date(this.inspectionDetail.record.inspectionBeginTime).getTime();
            var date = checkEndTime - checkBeginTime; //时间差的毫秒数
            var endTime = new Date(this.inspectionDetail.record.endTime).getTime();
            var beginTime = new Date(this.inspectionDetail.record.beginTime).getTime();

            //计划时间
            var date3 = endTime - beginTime;
            if(checkBeginTime>endTime){
              //实际点检时间 ok
              this.styleObject4.width='66%'
              this.styleObject5.width='0%'
              //计划点检时间
              this.styleObject6.width='0%'
              this.styleObject7.width='66%'

              this.styleObject1.width = '50%'
              this.styleObject2.width = '50%'
              this.styleObject3.width = '0%'
            }else if(beginTime<checkBeginTime && checkEndTime>endTime){
              var a = ((checkBeginTime-beginTime) /date3)*0.8*100
              var b = ((endTime - checkEndTime) /date3)
              //实际点检时间
              this.styleObject4.width=(a<0?0:a)+'%'
              this.styleObject5.width='0%'
              //计划点检时间
              this.styleObject6.width='0%'
              this.styleObject7.width='20%'

              this.styleObject1.width = (a<0?0:a)+'%'
              this.styleObject2.width = (100-(a<0?0:a)) +'%'
              this.styleObject3.width = '0%'
            }else if(beginTime>checkBeginTime && checkEndTime>endTime){
              //实际点检时间
              this.styleObject4.width='0%'
              this.styleObject5.width='0%'
              //计划点检时间
              this.styleObject6.width='20%'
              this.styleObject7.width='20%'

              this.styleObject1.width = '0%'
              this.styleObject2.width = '100%'
              this.styleObject3.width = '0%'
            }else if (beginTime>checkBeginTime && checkEndTime<endTime){
              var b = ((endTime - checkEndTime) /date3)*0.8*100
              //实际点检时间
              this.styleObject4.width='0%'
              this.styleObject5.width= b+'%'
              //计划点检时间
              this.styleObject6.width='20%'
              this.styleObject7.width='0%'

              this.styleObject1.width = '0%'
              this.styleObject2.width = (100-b)+'%'
              this.styleObject3.width = b+'%'
            }else{
              var a = ((checkBeginTime-beginTime) /date3)*100
              var b = ((endTime - checkEndTime) /date3)*100
              this.styleObject4.width=(a<0?0:a)+'%'
              this.styleObject5.width=(b<0?0:b)+'%'
              //计划点检时间
              this.styleObject6.width='0%'
              this.styleObject7.width='0%'

              this.styleObject1.width = (a<0?0:a)+'%'
              this.styleObject2.width = (100-(a<0?0:a) -(b<0?0:b)) +'%'
              this.styleObject3.width = (b<0?0:b)+'%'
            }
          }else{
            //实际点检时间
            this.styleObject4.paddingLeft='0%'
            this.styleObject5.paddingRight='0%'
            //计划点检时间
            this.styleObject6.paddingLeft='0%'
            this.styleObject7.paddingRight='0%'

            this.styleObject1.width = '100%'
            this.styleObject2.width = '0%'
            this.styleObject3.width = '0%'
          }
        }
      }).catch((response) => {
        console.log(response)
      })
    },

    changeSelectMonth() {
      this.tableDataTreeEdit.monthD = '';
      for (const k in this.monthOptions) {
        if (this.tableDataTreeEdit.month === this.monthOptions[k]) {
          this.monthDOptions = this.monthOptionsObj[this.tableDataTreeEdit.month]
        }
      }
    },
    search() {
		let param = {
			pageNum: 1,
			pageSize: this.pageSize
		}
		this.searchPage(param);
    },
    searchStauts(param) {
		inspection.selectRecordStatus(param).then((response) => {
			const data = response.data;
			if (data.code == "1") {
				this.spotStatusNumList[0].num = data.data.status0;
				this.spotStatusNumList[1].num = data.data.status1;
				this.spotStatusNumList[2].num = data.data.status2;
				this.spotStatusNumList[3].num = data.data.status3;
				this.spotStatusNumList[4].num = data.data.status4;
				this.spotStatusNumList[5].num = data.data.statusAll;
			}
		}).catch((response) => {
			console.log(response)
		})
    },
    searchPage(param) {
		for (var item of this.spotStatusNumList) {
			if (item.check) {
				this.searchDataList.inspectionStatus.push(item.type);
			}
		}
		this.searchDataList.beginTime = this.Readytime[0] + " 00:00:00";
		this.searchDataList.endTime = this.Readytime[1] + " 23:59:59";
		var dataParam = this.searchDataList;
		var newParam = Object.assign(param, dataParam);
		this.searchStauts(newParam);
		this.pageNum = newParam.pageNum;
		this.pageSize = newParam.pageSize;
		this.selectInspectionRecordPage(newParam);
    },
	selectInspectionRecordPage(param){
		inspection.selectInspectionRecordPage(param).then((response) => {
			const data = response.data;
			if (data.code == "1") {
				this.tableDataTreeTime = data.data.records;
				this.searchDataList.inspectionStatus = [];
				this.multipleSelection = [];
				this.pageSize = data.data.size;
				this.pageCount = data.data.total;
				this.pageNum = data.data.current;
				this.$refs['pageModel'].setCurrent(this.pageNum);
			} else {
				utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
			}
		}).catch((response) => {
			console.log(response)
		})
	},
    getDeviceMes(data) {
    },
    getcheckList() {
		file.getCheckList().then((response) => {
			const data = response.data;
			if (data.code == "1") {
				this.checkList = data.data;
			}
		}).catch((response) => {
			console.log(response)
		})
    },
	querySearchAsync1(queryString, cb) {
		let param = {
			name: this.searchDataList.deptName
		}
		file.selectDept(param).then((response) => {
			const data = response.data;
			if (data.code == "1") {
				cb(data.data)
			}
		}).catch((response) => {
			console.log(response)
		})
	},
	handleSelect1(item) {
		this.searchDataList.deptName = item.name
		this.searchDataList.deptId = item.id
	},
	querySearchAsync2(queryString, cb) {
		file.selectUser(this.searchDataList.userName).then((response) => {
			const data = response.data;
			if (data.code == "1") {
				cb(data.data)
			}
		}).catch((response) => {
			console.log(response)
		})
	},
	handleSelect2(item) {
		this.searchDataList.userName = item.fullName
		this.searchDataList.userId = item.id
	},
	getNowTime() {
		let zeroTime = new Date();
		let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
			1; //月份从0开始，因此要+1
		let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
		let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
		return now;
	},
	getThreeDaysAgo() {
		let myDate = new Date();
		let lw = new Date(myDate - 1000 * 60 * 60 * 24 * 30); //最后一个数字30可改，30天的意思
		let lastY = lw.getFullYear();
		let lastM = lw.getMonth() + 1;
		let lastD = lw.getDate();
		let startData =
			lastY +
			"-" +
			(lastM < 10 ? "0" + lastM : lastM) +
			"-" +
			(lastD < 10 ? "0" + lastD : lastD); //三十天之前日期
		return startData;
	},
	getFirstDay(){ //当前月第一天
		var y = new Date().getFullYear(); //获取年份
		var m = new Date().getMonth() + 1; //获取月份
		var d = '01';
		m = m < 10 ? '0' + m : m; //月份补 0

		return [y,m,d].join("-")
	},
	getLastDay(){ //当前月最后一天
		var y = new Date().getFullYear(); //获取年份
		var m = new Date().getMonth() + 1; //获取月份
		var d = new Date(y, m, 0).getDate(); //获取当月最后一日
		m = m < 10 ? '0' + m : m; //月份补 0
		d = d < 10 ? '0' + d : d; //日数补 0

		return [y,m,d].join("-")
	},
  },
  created() {
	this.Readytime = [this.getFirstDay(), this.getLastDay()]
    this.getcheckList();
    this.search({pageNum: 1,pageSize:this.pageSize,})
    this.MenuRoleList = this.$store.getters.getMenu;
    console.log('截取后的数据', this.ceshi.split("@"))
    this.$set(this.monthOptionsObj, this.$t('label_245'), ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
    this.$set(this.monthOptionsObj, this.$t('label_242'), ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']);
    this.$set(this.monthOptionsObj, this.$t('label_238'), ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']);
  }
}
</script>

<style>
.type_style{
  font-weight: bold;
  color: #4BB699;
  font-size: 10px;
}
.down_box{
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  border-top: 1px  #CACACA solid;
  margin-top: 20px;
}
.title_style{
  font-weight: 600;
  margin-right: 80px;
}
.number_one{
  font-size: 30px;
  color: #1159C2;
  margin-left: 10px;
  margin-right: 10px;
}
.number_two{
  font-size: 20px;
  color: #929497;
}
.cehsi{
  width: 100%;
  height: 400px;
  display: flex;
}
.left_box{
  width: 25%;
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #E1E1E1;
}
.right_box{
  width: 75%;
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #E1E1E1;
  margin-left: 20px;
}
.left_title{
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: #EFEFEF;
  font-weight:600;
  padding-left: 30px;
  box-sizing: border-box;
}
.content_box{
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  box-sizing: border-box;
  border: 1px solid #E1E1E1;
  overflow: hidden;
}
.content_boxs{
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  box-sizing: border-box;
  border: 2px solid #93D2C1;
}
.equipment_wid{
  width: 130px;
  margin-left: 10px;
}
.bjmodel{
  margin-left: 10px;
  width: 200px;

}
.img_box{
  width: 50%;
  height: 100%;
  border: 1px solid #000000;
  margin-right: 30px;
}
#dialogImg .el-dialog{
  height: 600px;
}
#dialogImg .el-dialog__body{
  height: 546px;
  overflow: auto;
  padding:0;
}
</style>



// WEBPACK FOOTER //
// src/pages/dailyInspection/InspectionRecord.vue